import { PropertyAddressType } from "../pages/Properties/UpdateProperty/types";
import { ConfigType } from "../utils/requestAPI";

export type paginationType = {
  limit?: number;
  total?: number;
  totalPages?: number;
  currentPage?: number;
  page?: number;
  search?: string;
  type?: string;
};

type LandlordPropertyParamType = {
  landlordId?: string;
};

type TenantPropertyParamType = {
  tenantId?: string;
};

type ReviewDetails = {
  field: string;
  status: "accept" | "reject" | "";
  description?: string;
  files?: string[];
}[];

const properties = {
  getProperties: (params?: paginationType): ConfigType => {
    return {
      method: "get",
      url: "admins/properties",
      params,
    };
  },

  getPropertyReview: (id: string): ConfigType => {
    return {
      method: "get",
      url: `properties/${id}/review`,
    };
  },
  updateProperty: (
    id: string,
    data?: PropertyAddressType & { updateStep: number }
  ): ConfigType => {
    return {
      method: "put",
      url: `properties/${id}`,
      data,
    };
  },
  changeHistory: (id: string, params?: paginationType): ConfigType => {
    return {
      method: "get",
      url: `properties/${id}/history`,
      params,
    };
  },
  reviewProperty: (
    id: string | string[] | undefined,
    data?: ReviewDetails
  ): ConfigType => {
    return {
      method: "put",
      url: `properties/review/${id}`,
      data: { reviews: data },
    };
  },
  deleteProperty: (id: string | string[] | undefined): ConfigType => {
    return {
      method: "delete",
      url: `properties/${id}`,
    };
  },
  publishProperty: (id: string | string[] | undefined): ConfigType => {
    return {
      method: "patch",
      url: `properties/${id}/publish`,
    };
  },
  getSingleProperty: (id: string): ConfigType => {
    return {
      method: "get",
      url: `properties/${id}`,
    };
  },
  getLandlordProperty: (params: LandlordPropertyParamType): ConfigType => {
    return {
      method: "get",
      url: `admins/landlord-property`,
      params,
    };
  },

  getTenantBooking: (params: TenantPropertyParamType): ConfigType => {
    return {
      method: "get",
      url: `admins/tenant-booked-property`,
      params,
    };
  },

  getSearchProperty: (input: string): ConfigType => {
    return {
      method: "get",
      url: `common/google-maps-autocomplete`,
      params: {
        input,
      },
    };
  },
};

export default properties;
